import { useState } from 'react';
import SectionHeading from '../../components/SectionHeading';
import RichText from '../../components/RichText';
import Loader from '../../components/Loader';
import useFetch from '../../hooks/useFetch';
import { getFaqs } from '../../services/api';

const FALLBACK_FAQS = [
  {
    id: '1',
    question: 'What types of products do you offer?',
    answer:
      'We offer a wide range of wholesale products including Grocery & Gourmet, Home & Kitchen, Toys, Beauty, Health & Wellness, Personal Care, Office Supplies, and Pet items. Our catalog is curated for Amazon sellers seeking high ROI, low BSR SKUs.',
  },
  {
    id: '2',
    question: 'How do I apply for a wholesale account?',
    answer:
      'Simply fill out the wholesale application form on our website. Provide your business information and Amazon seller details. Our team reviews applications and approves accounts typically within 24–48 hours.',
  },
  {
    id: '3',
    question: 'Do you provide LOA and Amazon-compliant invoices?',
    answer:
      'Yes. We provide Letters of Authorization (LOA) for Amazon FBA approval and invoices that meet Amazon\'s documentation requirements — essential for ungating restricted categories and brands.',
  },
  {
    id: '4',
    question: 'Do you offer drop shipping?',
    answer:
      'Yes. We offer drop shipping services for online retailers and Amazon FBA sellers who prefer not to hold inventory. We ship directly from our warehouse to Amazon fulfillment centers or your end customers.',
  },
  {
    id: '5',
    question: 'What payment methods are accepted?',
    answer:
      'We accept ACH and WIRE transfers to ensure secure and efficient transactions for all wholesale accounts.',
  },
  {
    id: '6',
    question: 'What is the minimum order requirement?',
    answer:
      'Minimum order requirements vary by product category. Contact our team after applying for a wholesale account and we\'ll walk you through the specifics for your chosen product lines.',
  },
];

function FaqSection() {
  const { data, loading } = useFetch(() => getFaqs(), []);
  const [openId, setOpenId] = useState(null);
  const [initialized, setInitialized] = useState(false);

  const faqs = Array.isArray(data) && data.length > 0 ? data : FALLBACK_FAQS;

  // Open the first item by default once data is ready
  if (!initialized && faqs.length > 0) {
    setOpenId(faqs[0].id);
    setInitialized(true);
  }

  function toggle(id) {
    setOpenId((prev) => (prev === id ? null : id));
  }

  if (loading) {
    return (
      <section id="faq">
        <div className="section-inner">
          <Loader />
        </div>
      </section>
    );
  }

  return (
    <section id="faq">
      <div className="section-inner">
        <SectionHeading
          label="Got Questions?"
          title="Frequently Asked Questions"
          sub="Everything you need to know before getting started."
        />
        <div className="faq-list">
          {faqs.map((faq) => {
            const isOpen = openId === faq.id;
            return (
              <div className={`faq-item${isOpen ? ' open' : ''}`} key={faq.id}>
                <button className="faq-q" onClick={() => toggle(faq.id)}>
                  {faq.question}
                  <span className="faq-icon">+</span>
                </button>
                <div className="faq-a">
                  <RichText html={faq.answer} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default FaqSection;
